import React from "react"
import ModalConfig from "components/Stacker/config/ModalConfig"
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"
import { getDYArea } from "stackerConfig"
import "./AmountModal.scss"

function AmountModal(props) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const onButtonClick = () => {
    dispatch(toggleModal(ModalConfig.MODAL_STACKER_AMOUNT, false))
  }

  return (
    <ModalGeneric name={ModalConfig.MODAL_STACKER_AMOUNT} standard>
      <div className="AmountModal stacker-modal amount-modal text-center">
        <h5 className="linotype-didot-font">{LL[getDYArea()].limit()}</h5>
        <p className="mb-4">{LL[getDYArea()].limitDescription()}</p>
        <button
          className="btn btn-blackrect d-block mx-auto text-uppercase"
          onClick={onButtonClick}
        >
          Ok
        </button>
      </div>
    </ModalGeneric>
  )
}

export default AmountModal
